import React from 'react'

export function Error404() {
  return (
    <div>
        <h3>KATITO TE AMARE</h3>
    </div>
  );
}
